import { kaplanImportOptions } from "./kaplanImportOptions";

export const taskOptions = [
  ...kaplanImportOptions
]


// WEBPACK FOOTER //
// ./src/containers/pages/admin-portal/admin-task-portal/partials/taskOptions.js